<template>
  <div v-if="org">
    <div class="page-title mb-3">
      <mdb-icon icon="file-signature" /> 훈련계획서
    </div>
    <admin-org-select v-if="isAdmin" class="my-1" />
    <mdb-tbl hover sm>
      <mdb-tbl-head>
        <tr class="title">
          <th>
            <div class="clearfix">
              <div class="float-left">훈련 과정명</div>
              <div class="float-right text-right">
                훈련 년도:
                <select v-model="year" class="select-underline">
                  <option v-for="(year, yx) in years" :key="yx">{{
                    year
                  }}</option>
                </select>
              </div>
            </div>
          </th>
          <th style="width:60px">차수</th>
          <th style="width:100px">
            <select v-model="status" class="select-underline">
              <option v-for="(status, yx) in statusLabels" :key="yx">{{
                status
              }}</option>
            </select>
          </th>
          <th style="width:120px">강사</th>
          <th style="width:100px">시작일</th>
          <th style="width:100px">종료일</th>
          <th style="width:80px">
            <mdb-btn icon="plus" color="primary" class="p-1 m-0" @click="onNew"
              >추가</mdb-btn
            >
          </th>
        </tr>
      </mdb-tbl-head>

      <mdb-tbl-body>
        <tr v-for="(t, tx) in filteredTraining" :key="tx">
          <td>
            <span class="pointer" @click="onSelectTraining(t)">{{
              t.name
            }}</span>
          </td>
          <td>{{ t.seq }}</td>
          <td>{{ t.status }}</td>
          <td>{{ t.teacher && t.teacher.name }}</td>
          <td>{{ $strDate(t.startDate) }}</td>
          <td>{{ $strDate(t.endDate) }}</td>
          <td>
            <mdb-btn icon="copy" class="p-1 m-0" @click="onCopy(t)"
              >복사</mdb-btn
            >
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <modal-dlg
      v-if="modal"
      size="lg"
      icon="chalkboard-teacher"
      title="훈련 복사"
      :show="modal"
      @close="onClose"
    >
      <mdb-input label="새로운 훈련명" v-model="newTrainingTitle" />
      <mdb-input
        label="훈련년도"
        type="number"
        v-model="newYear"
        style="width:80px"
      />
      <div class="text-center">
        <mdb-btn
          class="py-2"
          color="primary"
          @click="onCopyTraining"
          icon="copy"
          :disabled="!newTrainingTitle"
          >복사하기</mdb-btn
        >
        <mdb-btn class="py-2" icon="times" @click="onClose">닫기</mdb-btn>
      </div>
    </modal-dlg>
    <modal-dlg
      v-if="newModal"
      size="lg"
      icon="chalkboard-teacher"
      title="훈련 생성"
      :show="newModal"
      @close="onNewClose"
    >
      <mdb-input label="새로운 훈련명" v-model="newTrainingTitle" />
      <mdb-input
        label="훈련년도"
        type="number"
        v-model="newYear"
        style="width:80px"
      />
      <div class="text-center">
        <mdb-btn
          class="py-2"
          color="primary"
          @click="onNewTraining"
          icon="save"
          :disabled="!newTrainingTitle"
          >생성하기</mdb-btn
        >
        <mdb-btn class="py-2" icon="times" @click="onNewClose">닫기</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import {} from "mdbvue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Training from "@/models/Training";
import AdminOrgSelect from "../../../../components/admin/AdminOrgSelect.vue";
export default {
  name: "StaffOpenTraining",
  components: { AdminOrgSelect },
  props: [],
  data: () => ({
    TAG: "StaffOpenTrainingPage >>",
    years: [],
    year: "",
    trainings: {},
    statusLabels: ["모두", "진행중", "모집중", "종료"],
    status: "모두",
    copyTraining: "",
    newTrainingTitle: "",
    newYear: 0,
    modal: false,
    newModal: false
  }),
  computed: {
    ...mapState("auth", ["profile", "org"]),
    ...mapGetters("auth", ["isAdmin", "isManager"]),
    filteredTraining () {
      console.log(this.trainings);
      if (this.status === "모두") {
        return this.trainings ? this.trainings[this.year] : [];
      } else {
        return this.trainings ? this.trainings[this.year].filter(t => t.status === this.status) : [];
      }
    }
  },
  methods: {
    ...mapMutations("training", ["setTraining"]),
    async load () {
      if (this.org && this.org._id) {
        const trainings = await Training.get({ org: this.org._id });
        this.trainings = trainings[this.org.name];
        if (this.trainings) {
          this.years = Object.keys(this.trainings)
            .sort()
            .reverse();
          this.year = this.years[0];
          this.status = "모두";
        } else {
          this.years = [new Date().getFullYear()];
          this.year = this.years[0];
          this.status = "모두";
        }
      }
    },
    onSelectTraining (training) {
      this.setTraining(training);
      this.$router.push({
        name: "StaffOpenTrainingIntro",
        query: { training: training._id }
      });
    },
    onCopy (t) {
      this.copyTraining = t._id;
      this.newTrainingTitle = "[복사본] " + t.name;
      this.modal = true;
    },
    async onCopyTraining () {
      if (this.newTrainingTitle === "") {
        alert("새로운 훈련명을 입력하세요");
        return;
      }
      if (this.copyTraining) {
        // 복사
        const clone = await this.$Training.copy(
          this.copyTraining,
          this.newTrainingTitle
        );
        this.setTraining(clone);
        alert("복사본 수정 화면으로 이동합니다.");
        this.onClose();
        this.$router.push({
          name: "StaffOpenTrainingIntro",
          query: { training: clone._id }
        });
      }
    },
    onClose () {
      this.copyTraining = "";
      this.newTrainingTitle = "";
      this.modal = false;
    },
    onNew () {
      this.newTrainingTitle = "";
      this.newYear = new Date().getFullYear();
      this.newModal = true;
    },
    onNewClose () {
      this.copyTraining = "";
      this.newTrainingTitle = "";
      this.newModal = false;
    },
    async onNewTraining () {
      if (!this.newTrainingTitle) {
        return alert("훈련명을 입력하세요.");
      }
      this.newYear = this.newYear && parseInt(this.newYear);
      let newTraining = await this.$Training.create(
        this.org._id,
        this.newTrainingTitle,
        this.newYear
      );
      newTraining.failScore = 0;
      newTraining = await newTraining.save();
      alert("훈련 수정 화면으로 이동합니다.");
      this.onClose();
      this.$router.push({
        name: "StaffOpenTrainingIntro",
        query: { training: newTraining._id }
      });
    }
  },
  watch: {
    org: "load",
    year () {
      this.status = "모두";
    }
  },
  created () {
    this.load();
  }
};
</script>
